import { getCurrentHubId } from '../api/hubs';

export const HUB_SCAN_STATUSES = {
  RECEIVED_AT_HUB: 'RECEIVED_AT_HUB',
  DISPATCHED_TO_HUB: 'DISPATCHED_TO_HUB',
  CANCEL_DISPATCH: 'CANCEL_DISPATCH',
};

export const HUB_SCAN_LABELS = {
  RECEIVED_AT_HUB: 'Received at the hub',
  DISPATCHED_TO_HUB: 'Dispatched from hub',
  CANCEL_DISPATCH: 'Cancel dispatch',
};

export const isLegacyHubScanStatus = (status) => {
  const value = String(status || '');
  return value.startsWith('arrived at hub') || value.startsWith('departed from hub');
};

export const formatHubScanStatus = (status) => {
  if (!status) return 'Unknown';
  if (HUB_SCAN_LABELS[status]) return HUB_SCAN_LABELS[status];
  return String(status)
    .replace(/_/g, ' ')
    .toLowerCase()
    .replace(/\b\w/g, (c) => c.toUpperCase());
};

/**
 * Decide which hub actions the current hub may take for a package.
 * @param {object} pkg package payload from by_consignment
 */
export const getAvailableHubActions = (pkg, hubId = getCurrentHubId()) => {
  const me = Number(hubId);
  if (!pkg || !me) {
    return { actions: [], reason: 'Package not loaded for this hub.' };
  }

  const currentHubId = Number(pkg.currentHubId);
  const nextHubId = pkg.nextHubId == null || pkg.nextHubId === '' ? null : Number(pkg.nextHubId);
  const actions = [];

  if (nextHubId === me) {
    actions.push(HUB_SCAN_STATUSES.RECEIVED_AT_HUB);
  }

  if (currentHubId === me && nextHubId == null) {
    actions.push(HUB_SCAN_STATUSES.DISPATCHED_TO_HUB);
  }

  if (currentHubId === me && nextHubId != null) {
    actions.push(HUB_SCAN_STATUSES.CANCEL_DISPATCH);
  }

  if (actions.length === 0) {
    return {
      actions: [],
      reason:
        'No hub action available. Package may be at another hub, already in transit to a different hub, or not accessible here.',
    };
  }

  return { actions, reason: null };
};
